import { FormBase } from 'core/components';

export default class CancelForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'cancelReasonId',
					label: 'CANCELVIEW.CANCELREASON',
					rules: 'required'
				},
			],
		};
	}
}
